"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicrophoneReadiness = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ReadinessCheck = _interopRequireDefault(require("../ReadinessCheck"));
var _constants = require("../../../constants");
var MicrophoneReadiness = exports.MicrophoneReadiness = function MicrophoneReadiness(_ref) {
  var status = _ref.status,
    onRetry = _ref.onRetry,
    hideBottomBorder = _ref.hideBottomBorder,
    statusText = _ref.statusText,
    messageBody = _ref.messageBody,
    presenterId = _ref.presenterId,
    microphone = _ref.microphone;
  return /*#__PURE__*/_react["default"].createElement(_ReadinessCheck["default"], {
    title: "Microphone",
    status: status,
    statusText: statusText,
    onRetry: onRetry,
    hideBottomBorder: hideBottomBorder,
    failedText: microphone === _constants.NO_DEVICE_FOUND ? 'No microphone device detected' : 'Browser permission not granted',
    presenterId: presenterId
  }, messageBody ? /*#__PURE__*/_react["default"].createElement("p", null, messageBody) : /*#__PURE__*/_react["default"].createElement("p", null, "\n        Check your browser privacy settings\n        allow ".concat(window.location.hostname, " access to\n        your microphone.\n      ")));
};
MicrophoneReadiness.defaultProps = {
  status: _constants.CHECKING
};
MicrophoneReadiness.propTypes = {
  status: _propTypes.string.isRequired,
  messageBody: _propTypes.string,
  statusText: _propTypes.string,
  onRetry: _propTypes.func,
  hideBottomBorder: _propTypes.bool,
  presenterId: _propTypes.string,
  microphone: _propTypes.string
};